<div class="d-flex justify-content-center">
  <div class="error-img"></div>
  <div>
    <p i18n="@@transactions.detail.check-image.server-error">Something went wrong. Please try again later.</p>
  </div>
</div>;
